// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import {
//   Container, Typography, Grid, Card, CardContent,
//   Divider, Box, Button, CircularProgress, TextField,
//   MenuItem, Select, Pagination, Alert, Chip
// } from '@mui/material';
// import * as XLSX from 'xlsx';
// import { styled } from '@mui/material/styles';
// import Header1 from '../Header/Header1';
// import Footer2 from '../Footer/Footer2';

// const API_URL = process.env.REACT_APP_API_URL;

// /* ------------------ ★ MODERN STYLED COMPONENTS ★ ------------------ */

// // Neon card with glassmorphism
// const NeonGlassCard = styled(Card)(() => ({
//   background: 'rgba(255,255,255,0.05)',
//   borderRadius: '16px',
//   padding: '6px',
//   backdropFilter: 'blur(8px)',
//   border: '1px solid rgba(255,255,255,0.12)',
//   boxShadow: '0 10px 25px rgba(0,0,0,0.4)',
//   transition: 'all .25s ease',
//   '&:hover': {
//     transform: 'translateY(-6px)',
//     boxShadow: '0 20px 45px rgba(0, 191, 255, 0.4)',
//     borderColor: '#00bfff',
//   },
// }));

// // Neon primary button
// const NeonButton = styled(Button)(() => ({
//   background: 'linear-gradient(90deg, #00bfff, #7f00ff)',
//   color: '#000',
//   fontWeight: 'bold',
//   textTransform: 'none',
//   padding: '8px 14px',
//   borderRadius: '30px',
//   transition: '0.25s',
//   '&:hover': {
//     boxShadow: '0 0 15px #00bfff',
//     opacity: 0.9,
//   },
// }));

// // Delete button with red pulse animation
// const DangerButton = styled(Button)(() => ({
//   color: '#ff4d4d',
//   borderColor: '#ff4d4d',
//   textTransform: 'none',
//   transition: '0.25s',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: 'rgba(255,0,0,0.15)',
//     borderColor: '#ff1a1a',
//     boxShadow: '0 0 10px rgba(255,50,50,0.6)',
//   },
// }));

// // Search bar styling
// const SearchField = styled(TextField)(() => ({
//   input: {
//     color: '#fff',
//     backgroundColor: '#111',
//     padding: '10px',
//     borderRadius: '8px',
//   },
//   '& .MuiOutlinedInput-root': {
//     '& fieldset': { borderColor: '#333' },
//     '&:hover fieldset': { borderColor: '#777' },
//     '&.Mui-focused fieldset': { borderColor: '#00bfff' },
//   },
// }));

// /* ------------------------------------------------------------------ */

// function AdminCareers() {
//   const [applications, setApplications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [search, setSearch] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(6);
//   const searchRef = useRef(null);

//   const fetchApplications = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_URL}/get_applications/`);
//       setApplications(res.data);
//     } catch {
//       setError('Failed to fetch applications');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchApplications(); }, []);
//   useEffect(() => { if (searchRef.current) searchRef.current.focus(); }, [loading]);

//   const handleDelete = async (id) => {
//     if (!window.confirm('Delete this application permanently?')) return;

//     try {
//       await axios.patch(`${API_URL}/mark_application_inactive/${id}/`);
//       setApplications(prev => prev.filter(app => app.id !== id));
//     } catch {
//       setError('Failed to delete application');
//     }
//   };

//   const handleDownload = async (id, name) => {
//     try {
//       const res = await axios.get(`${API_URL}/resume/${id}/`);
//       const link = document.createElement('a');
//       link.href = res.data.url;
//       link.download = `${name}_Resume.pdf`;
//       link.click();
//     } catch {
//       setError('Failed to get resume URL');
//     }
//   };

//   const handleDownloadExcel = () => {
//   if (!applications || applications.length === 0) {
//     alert('No applications available to export.');
//     return;
//   }

//   const exportData = applications.map((app) => ({
//     Name: app.name,
//     Email: app.email,
//     Contact: app.contact,
//     Role: app.role,
//     Type: app.type,
//     'Applied Date': new Date(app.created_at).toLocaleString(),
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, 'Applications');

//   const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
//   XLSX.writeFile(workbook, `Career_Applications_${today}.xlsx`);
// };

//   /* ---------- SEARCH & PAGINATION ---------- */

//   const filteredApplications = applications.filter(app =>
//     `${app.name} ${app.email} ${app.contact} ${app.role}`
//       .toLowerCase()
//       .includes(search.toLowerCase())
//   );

//   const pageCount = Math.ceil(filteredApplications.length / rowsPerPage);

//   const paginatedApplications = filteredApplications.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   /* ------------------------------------------------------------------ */

//   return (
//     <div>
//       <Header1 />

//       <Container
//         sx={{
//           backgroundColor: '#000000ff',
//           minHeight: '100vh',
//           pt: 10,
//           pb: 6,
//           color: '#fff',
//         }}
//         maxWidth="lg"
//       >

//         {/* Title */}
//         <Typography
//           variant="h3"
//           align="center"
//           gutterBottom
//           sx={{
//             fontWeight: 700,
//             letterSpacing: 2,
//             mb: 4,
//             backgroundImage: 'linear-gradient(90deg, #00eaff, #ff00ff)',
//             WebkitBackgroundClip: 'text',
//             color: 'transparent',
//             animation: 'glitch 2.5s infinite alternate',
//           }}
//         >
//           Admin — Career Applications
//         </Typography>

//         {/* Summary and Search Row */}
//         <Box
//           display="flex"
//           flexDirection={{ xs: 'column', sm: 'row' }}
//           alignItems="center"
//           justifyContent="space-between"
//           sx={{ mb: 4, gap: 2 }}
//         >
//           <Chip
//             label={`Total: ${applications.length} | Matching: ${filteredApplications.length}`}
//             sx={{
//               background: 'rgba(0,255,255,0.15)',
//               color: '#00eaff',
//               fontWeight: 'bold',
//               borderRadius: '8px',
//               px: 2,
//               py: 1,
//             }}
//           />

//           <Box display="flex" gap={2} flexWrap="wrap">

//             <SearchField
//               inputRef={searchRef}
//               placeholder="Search name, email, contact, role..."
//               value={search}
//               onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
//               size="small"
//               sx={{ width: { xs: '100%', sm: '290px' } }}
//             />

//             <Select
//               value={rowsPerPage}
//               onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
//               size="small"
//               sx={{
//                 color: '#fff',
//                 backgroundColor: '#111',
//                 '& .MuiOutlinedInput-notchedOutline': { borderColor: '#333' },
//                 '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#777' },
//                 '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#00bfff' },
//                 minWidth: 85,
//               }}
//             >
//               {[6, 12, 18].map(num => <MenuItem key={num} value={num}>{num}/page</MenuItem>)}
//             </Select>
//              <NeonButton onClick={handleDownloadExcel}>
//   Download Excel
// </NeonButton>
//           </Box>
         
//         </Box>

//         {/* Loading & Error */}
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//             <CircularProgress sx={{ color: '#00bfff' }} />
//           </Box>
//         ) : error ? (
//           <Alert severity="error" sx={{ mt: 3 }}>{error}</Alert>
//         ) : filteredApplications.length === 0 ? (
//           <Typography align="center" variant="h6" sx={{ mt: 6, color: '#bbb' }}>
//             No applications match your search...
//           </Typography>
//         ) : (
//           <>
//             {/* Applications Grid */}
//             <Grid container spacing={4}>
//               {paginatedApplications.map(app => (
//                 <Grid item xs={12} sm={6} md={4} key={app.id}>
//                   <NeonGlassCard>
//                     <CardContent>

//                       <Typography
//                         variant="h6"
//                         sx={{
//                           fontWeight: 'bold',
//                           color: '#00eaff',
//                           fontSize: '1.25rem',
//                           mb: 1,
//                         }}
//                       >
//                         {app.name}
//                       </Typography>

//                       <Divider sx={{ backgroundColor: '#333', mb: 2 }} />

//                       <Typography sx={{ color: '#ccc', mb: 0.5 }}>
//                         <strong>Email:</strong> {app.email}
//                       </Typography>
//                       <Typography sx={{ color: '#ccc', mb: 0.5 }}>
//                         <strong>Contact:</strong> {app.contact}
//                       </Typography>
//                       <Typography sx={{ color: '#ccc', mb: 0.5 }}>
//                         <strong>Role:</strong> {app.role}
//                       </Typography>
//                       <Typography sx={{ color: '#ccc', mb: 0.5 }}>
//                         <strong>Type:</strong> {app.type}
//                       </Typography>
//                       <Typography sx={{ color: '#ccc' }}>
//                         <strong>Applied:</strong> {new Date(app.created_at).toLocaleString()}
//                       </Typography>

//                       {/* Buttons */}
//                       <Box sx={{ mt: 3, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
//                         <NeonButton
//                           fullWidth
//                           onClick={() => handleDownload(app.id, app.name)}
//                         >
//                           View / Download Resume
//                         </NeonButton>

//                         {/* <DangerButton
//                           fullWidth
//                           variant="outlined"
//                           onClick={() => handleDelete(app.id)}
//                         >
//                           Delete
//                         </DangerButton> */}
//                       </Box>

//                     </CardContent>
//                   </NeonGlassCard>
//                 </Grid>
//               ))}
//             </Grid>

//             {/* Pagination */}
//             {pageCount > 1 && (
//               <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
//                 <Pagination
//                   count={pageCount}
//                   page={currentPage}
//                   onChange={(e, val) => setCurrentPage(val)}
//                   color="primary"
//                   size="large"
//                   sx={{
//                     '& .MuiPaginationItem-root': {
//                       color: '#00bfff',
//                     },
//                     '& .Mui-selected': {
//                       background:
//                         'linear-gradient(90deg, #00eaff, #7f00ff) !important',
//                       color: '#000 !important',
//                       boxShadow: '0 0 10px #00eaff',
//                     },
//                   }}
//                 />
//               </Box>
//             )}
//           </>
//         )}
//       </Container>

//       <Footer2 />
//     </div>
//   );
// }

// export default AdminCareers;



import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Container, Typography, Grid, Card, CardContent,
  Divider, Box, Button, CircularProgress, TextField,
  MenuItem, Select, Pagination, Alert, Chip,
  Dialog, DialogTitle, DialogContent, IconButton,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, useMediaQuery,
} from '@mui/material';
import * as XLSX from 'xlsx';
import { styled, useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

const API_URL = process.env.REACT_APP_API_URL;

/* ------------------ ★ MODERN STYLED COMPONENTS ★ ------------------ */

// Neon card with glassmorphism
const NeonGlassCard = styled(Card)(() => ({
  background: 'rgba(255,255,255,0.05)',
  borderRadius: '16px',
  padding: '6px',
  backdropFilter: 'blur(8px)',
  border: '1px solid rgba(255,255,255,0.12)',
  boxShadow: '0 10px 25px rgba(0,0,0,0.4)',
  transition: 'all .25s ease',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: '0 20px 45px rgba(0, 191, 255, 0.4)',
    borderColor: '#00bfff',
  },
}));

// Neon primary button
const NeonButton = styled(Button)(() => ({
  background: 'linear-gradient(90deg, #00bfff, #7f00ff)',
  color: '#000',
  fontWeight: 'bold',
  textTransform: 'none',
  padding: '8px 14px',
  borderRadius: '30px',
  transition: '0.25s',
  '&:hover': {
    boxShadow: '0 0 15px #00bfff',
    opacity: 0.9,
  },
}));

// Delete button with red pulse animation
const DangerButton = styled(Button)(() => ({
  color: '#ff4d4d',
  borderColor: '#ff4d4d',
  textTransform: 'none',
  transition: '0.25s',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: 'rgba(255,0,0,0.15)',
    borderColor: '#ff1a1a',
    boxShadow: '0 0 10px rgba(255,50,50,0.6)',
  },
}));

// Search bar styling
const SearchField = styled(TextField)(() => ({
  input: {
    color: '#fff',
    backgroundColor: '#111',
    padding: '10px',
    borderRadius: '8px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: '#333' },
    '&:hover fieldset': { borderColor: '#777' },
    '&.Mui-focused fieldset': { borderColor: '#00bfff' },
  },
}));

/* ------------------------------------------------------------------ */

function AdminCareers() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const searchRef = useRef(null);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [downloadLogs, setDownloadLogs] = useState([]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const fetchApplications = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/get_applications/`);
      setApplications(res.data);

    } catch {
      setError('Failed to fetch applications');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchApplications(); }, []);
  useEffect(() => { if (searchRef.current) searchRef.current.focus(); }, [loading]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this application permanently?')) return;
    try {
      await axios.patch(`${API_URL}/mark_application_inactive/${id}/`);
      setApplications(prev => prev.filter(app => app.id !== id));
    } catch {
      setError('Failed to delete application');
    }
  };

  const handleDownload = async (id, name) => {
    try {
      const res = await axios.get(`${API_URL}/resume/${id}/`);
      const link = document.createElement('a');
      link.href = res.data.url;
      link.download = `${name}_Resume.pdf`;
      link.click();
    } catch {
      setError('Failed to get resume URL');
    }
  };

  const handleDownloadExcel = async () => {
    if (!applications || applications.length === 0) {
      alert('No applications available to export.');
      return;
    }

    const exportData = applications.map((app) => ({
      Name: app.name,
      Email: app.email,
      Contact: app.contact,
      Role: app.role,
      Type: app.type,
      'Applied Date': new Date(app.created_at).toLocaleString(),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Applications');

    const today = new Date().toISOString().split('T')[0];
    const filename = `Career_Applications_${today}.xlsx`;
    XLSX.writeFile(workbook, filename);

    // Log to backend — non-fatal if it fails (download already completed)
    try {

      await axios.post(`${API_URL}/log-download/`, {
        filename,
        record_count: applications.length,
        

      } ,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },});
    } catch (err) {
  console.error("DOWNLOAD LOG ERROR:", err);
}
  };

  const handleViewLogs = async () => {
    try {
      const res = await axios.get(`${API_URL}/download-history/`);
      setDownloadLogs(res.data);
      setHistoryOpen(true);
    } catch {
      setError('Failed to load download history');
    }
  };

  /* ---------- SEARCH & PAGINATION ---------- */

  const filteredApplications = applications.filter(app =>
    `${app.name} ${app.email} ${app.contact} ${app.role}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const pageCount = Math.ceil(filteredApplications.length / rowsPerPage);

  const paginatedApplications = filteredApplications.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  /* ------------------------------------------------------------------ */

  return (
    <div>
      <Header1 />

      <Container
        sx={{
          backgroundColor: '#000000ff',
          minHeight: '100vh',
          pt: 10,
          pb: 6,
          color: '#fff',
        }}
        maxWidth="lg"
      >

        {/* Title */}
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            letterSpacing: 2,
            mb: 4,
            backgroundImage: 'linear-gradient(90deg, #00eaff, #ff00ff)',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            animation: 'glitch 2.5s infinite alternate',
          }}
        >
          Admin — Career Applications
        </Typography>

        {/* Summary and Search Row */}
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 4, gap: 2 }}
        >
          <Chip
            label={`Total: ${applications.length} | Matching: ${filteredApplications.length}`}
            sx={{
              background: 'rgba(0,255,255,0.15)',
              color: '#00eaff',
              fontWeight: 'bold',
              borderRadius: '8px',
              px: 2,
              py: 1,
            }}
          />

          <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">

            <SearchField
              inputRef={searchRef}
              placeholder="Search name, email, contact, role..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
              size="small"
              sx={{ width: { xs: '100%', sm: '290px' } }}
            />

            <Select
              value={rowsPerPage}
              onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
              size="small"
              sx={{
                color: '#fff',
                backgroundColor: '#111',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#333' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#777' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#00bfff' },
                minWidth: 85,
              }}
            >
              {[6, 12, 18].map(num => <MenuItem key={num} value={num}>{num}/page</MenuItem>)}
            </Select>

            <NeonButton onClick={handleDownloadExcel}>
              Download Excel
            </NeonButton>

            <Button
              onClick={handleViewLogs}
              size="small"
              sx={{
                color: '#00eaff',
                borderColor: '#00eaff',
                border: '1px solid',
                borderRadius: '20px',
                textTransform: 'none',
                px: 2,
                whiteSpace: 'nowrap',
                '&:hover': { background: 'rgba(0,234,255,0.08)' },
              }}
            >
              View Download History
            </Button>

          </Box>
        </Box>

        {/* Loading & Error */}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress sx={{ color: '#00bfff' }} />
          </Box>
        ) : error ? (
          <Alert severity="error" sx={{ mt: 3 }}>{error}</Alert>
        ) : filteredApplications.length === 0 ? (
          <Typography align="center" variant="h6" sx={{ mt: 6, color: '#bbb' }}>
            No applications match your search...
          </Typography>
        ) : (
          <>
            {/* Applications Grid */}
            <Grid container spacing={4}>
              {paginatedApplications.map(app => (
                <Grid item xs={12} sm={6} md={4} key={app.id}>
                  <NeonGlassCard>
                    <CardContent>

                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 'bold',
                          color: '#00eaff',
                          fontSize: '1.25rem',
                          mb: 1,
                        }}
                      >
                        {app.name}
                      </Typography>

                      <Divider sx={{ backgroundColor: '#333', mb: 2 }} />

                      <Typography sx={{ color: '#ccc', mb: 0.5 }}>
                        <strong>Email:</strong> {app.email}
                      </Typography>
                      <Typography sx={{ color: '#ccc', mb: 0.5 }}>
                        <strong>Contact:</strong> {app.contact}
                      </Typography>
                      <Typography sx={{ color: '#ccc', mb: 0.5 }}>
                        <strong>Role:</strong> {app.role}
                      </Typography>
                      <Typography sx={{ color: '#ccc', mb: 0.5 }}>
                        <strong>Type:</strong> {app.type}
                      </Typography>
                      <Typography sx={{ color: '#ccc' }}>
                        <strong>Applied:</strong> {new Date(app.created_at).toLocaleString()}
                      </Typography>

                      {/* Buttons */}
                      <Box sx={{ mt: 3, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                        <NeonButton
                          fullWidth
                          onClick={() => handleDownload(app.id, app.name)}
                        >
                          View / Download Resume
                        </NeonButton>

                        {/* <DangerButton
                          fullWidth
                          variant="outlined"
                          onClick={() => handleDelete(app.id)}
                        >
                          Delete
                        </DangerButton> */}
                      </Box>

                    </CardContent>
                  </NeonGlassCard>
                </Grid>
              ))}
            </Grid>

            {/* Pagination */}
            {pageCount > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                <Pagination
                  count={pageCount}
                  page={currentPage}
                  onChange={(e, val) => setCurrentPage(val)}
                  color="primary"
                  size="large"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      color: '#00bfff',
                    },
                    '& .Mui-selected': {
                      background:
                        'linear-gradient(90deg, #00eaff, #7f00ff) !important',
                      color: '#000 !important',
                      boxShadow: '0 0 10px #00eaff',
                    },
                  }}
                />
              </Box>
            )}
          </>
        )}
      </Container>

      {/* ── Download History Dialog ── */}
      <Dialog
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: '#0d0d0d',
            border: '1px solid rgba(0,234,255,0.2)',
            borderRadius: { xs: 0, md: '16px' },
            color: '#fff',
            backgroundImage: 'none',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(0,234,255,0.12)',
            pb: 2,
            backgroundImage: 'linear-gradient(90deg, #00eaff, #7f00ff)',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            fontWeight: 700,
            letterSpacing: 1,
            fontSize: { xs: '1.1rem', sm: '1.35rem' },
          }}
        >
          Download History
          <IconButton
            onClick={() => setHistoryOpen(false)}
            size="small"
            sx={{
              color: '#aaa',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px',
              ml: 2,
              '&:hover': {
                color: '#fff',
                borderColor: '#00bfff',
                background: 'rgba(0,191,255,0.1)',
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          {downloadLogs.length === 0 ? (
            <Typography
              sx={{ color: '#888', p: 4, textAlign: 'center', fontSize: '0.95rem' }}
            >
              No downloads recorded yet.
            </Typography>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: 'transparent',
                boxShadow: 'none',
                maxHeight: { xs: 'calc(100vh - 140px)', md: '520px' },
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {['#', 'User', 'Downloaded At', 'File', 'Records'].map(col => (
                      <TableCell
                        key={col}
                        sx={{
                          backgroundColor: 'rgba(0,234,255,0.07)',
                          color: '#00eaff',
                          fontWeight: 700,
                          fontSize: '0.78rem',
                          letterSpacing: '0.08em',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid rgba(0,234,255,0.18)',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {downloadLogs.map((log, i) => (
                    <TableRow
                      key={log.id ?? i}
                      sx={{
                        '&:hover': { backgroundColor: 'rgba(255,255,255,0.03)' },
                        '& td': { borderBottom: '1px solid rgba(255,255,255,0.05)' },
                      }}
                    >
                      <TableCell sx={{ color: '#555', fontSize: '0.82rem' }}>
                        {i + 1}
                      </TableCell>
                      <TableCell sx={{ color: '#fff', fontSize: '0.85rem' }}>
                        {log.downloaded_by}
                      </TableCell>
                      <TableCell
                        sx={{ color: '#aaa', fontSize: '0.82rem', whiteSpace: 'nowrap' }}
                      >
                        {new Date(log.downloaded_at).toLocaleString()}
                      </TableCell>
                      <TableCell sx={{ color: '#aaa', fontSize: '0.82rem' }}>
                        {log.filename}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: '#00eaff',
                          fontWeight: 700,
                          fontSize: '0.85rem',
                          textAlign: 'center',
                        }}
                      >
                        {log.record_count}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>

      <Footer2 />
    </div>
  );
}

export default AdminCareers;